import Component from '@glimmer/component'
import PopoverDropdownStandard from '@blakeelearning/popovers/components/popover/dropdowns/standard'
import { on } from '@ember/modifier'
import { fn } from '@ember/helper'
import { t } from 'ember-intl'
import { cached } from '@glimmer/tracking'

interface Args {
  disabled?: boolean
  stickerName?: string | null
  onSelect?: (stickerName: string | null) => void
}

const STICKER_NAMES = [
  'ant',
  'astronaut',
  'bee',
  'book',
  'cat',
  'frog',
  'robotflash',
  'rooster',
  'star',
  'teddy',
  'turtle',
  't_rex',
]

export function getStickerFullPath(stickerName: string) {
  return `https://cdn-editor.writinglegends.com/owc/images/celebrations/main/${stickerName}.gif`
}

export class StickerSelector extends Component<Args> {
  @cached
  get stickers() {
    return STICKER_NAMES.map((name) => ({
      name,
      url: getStickerFullPath(name),
      alt: `${name} sticker`,
    }))
  }

  selectSticker = (stickerName: string | null, closeDropdown?: () => void) => {
    if (this.args.onSelect) {
      this.args.onSelect(stickerName)
    }
    closeDropdown?.()
  }
  <template>
    <PopoverDropdownStandard @contentY="above" @disabled={{@disabled}} as |dropdown _ actions|>
      <button
        type="button"
        class="border-dusty-black-200 w-40 border-2 border-dashed p-5"
        data-test-sticker-selector
        disabled={{@disabled}}
        aria-haspopup="menu"
        {{dropdown.makeTrigger}}
      >
        {{#if @stickerName}}
          <img
            src={{getStickerFullPath @stickerName}}
            alt={{t "pages.recentWriting.viewWriting.feedbacks.celebrationSticker"}}
            width="90"
            height="90"
            class="mx-auto"
          />
        {{else}}
          {{t "pages.recentWriting.viewWriting.feedbacks.selectSticker"}}
        {{/if}}
      </button>
      <dropdown.content>
        <div class="border-2 bg-white">
          <div class="grid grid-cols-3 gap-2 p-2">
            {{#each this.stickers as |sticker|}}
              <button
                id={{sticker.name}}
                type="button"
                class="rounded border-2 p-1 text-center hover:border-blue-400"
                {{on "click" (fn this.selectSticker sticker.name actions.close)}}
              >
                <img src={{sticker.url}} alt={{sticker.alt}} width="90" height="90" class="mx-auto" />
              </button>
            {{/each}}

          </div>

          {{#if @stickerName}}
            <div class="my-2 flex justify-center"><button
                id="remove-sticker"
                type="button"
                class="bg-red-250 rounded-lg p-2 text-white"
                {{on "click" (fn this.selectSticker null actions.close)}}
              >{{t "pages.recentWriting.viewWriting.feedbacks.removeSticker"}}</button></div>
          {{/if}}
        </div>
      </dropdown.content>
    </PopoverDropdownStandard>
  </template>
}

export default StickerSelector
